/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/16
 */
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'react-router-redux';

const history = createHistory();

export default history;

export const reduxMiddleware = routerMiddleware(history);


// WEBPACK FOOTER //
// ./src/routes/history.js